import React from 'react';
import { Grid, Loader } from 'semantic-ui-react';
import MainButton from 'components/Buttons/MainButton';
import FolderListItem from './FolderListItem';
import CustomPagination from 'components/CustomPagination';

const _appointmentContainer = (status) => ({
	backgroundColor: '#fff',
	width: '100%',
	position: 'relative',
	padding: 10,
	display: 'flex',
	borderRadius: '0',
	marginTop: '5px',
	boxShadow: '0px 9px 35px -23px rgba(148,148,148,1)',
	alignItems: 'center',
	marginRight: 10,
	marginLeft: 10,
});

const FolderList = ({
	data: { list, page, pages, loading, prescriptionCount, listTotalCount },
	loadList,
	nextHandler,
	generalParameters,
	selectPatient,
	user,
	actionText,
	action,
}) => {
	if (loading)
		return (
			<div style={{ width: '100%', textAlign: 'center' }}>
				<Loader active inline />
			</div>
		);

	return (
		<Grid>
			<Grid.Row key={'appoint'} style={_appointmentContainer(false)}>
				<Grid.Column mobile={8} tablet={10} computer={12}>
					<div>
						<b>
							{prescriptionCount} prescription(s) {actionText} dans{' '}
							{listTotalCount} dossier(s)
						</b>
					</div>
				</Grid.Column>

				<Grid.Column
					mobile={8}
					tablet={6}
					computer={4}
					style={{ textAlign: 'right' }}
				>
					{list !== undefined && list.length > 0 && (
						<MainButton
							text='Dossier suivant'
							onClick={(e) => {
								if (e !== undefined) {
									e.preventDefault();
									e.stopPropagation();
								}
								nextHandler();
							}}
						/>
					)}
				</Grid.Column>
			</Grid.Row>
			{list?.map((l) => {
				return (
					<FolderListItem
						key={`folderItem-${l.id}`}
						folder={l}
						generalParameters={generalParameters}
						handleOnPress={() => selectPatient(l, action)}
						user={user}
					/>
				);
			})}
			<CustomPagination
				activePage={page}
				totalPages={pages}
				onPageChange={(e, { activePage }) => {
					loadList(activePage);
				}}
			/>
		</Grid>
	);
};

export default FolderList;
